import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import imagenLogin from "../../assets/images/loginpage.jpg";
import Logo from "../../assets/images/logo_azul.png";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase/firebaseConfig";

const LoginPage: React.FC = () => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function login(email: string, password: string) {
    setLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      console.log("Usuario autenticado:", userCredential.user);
      history.push("/admin"); // Redirigir al panel de administración
    } catch (error: any) {
      console.error("Error al iniciar sesión:", error);
      alert("Error: " + error.message); // Muestra una alerta con el mensaje de error
    }
    setLoading(false);
  }

  return (
    <div className="flex flex-col-reverse md:flex-row min-h-screen lg:items-center items-start lg:justify-center justify-end ">
      {/* Sección Izquierda - Formulario */}
      <div className="md:w-1/2 flex items-center justify-center p-8">
        <div className="max-w-md w-full justify-center items-center">
          <div className="flex w-full items-center justify-center mb-[20px]">
            <img
              src={Logo}
              alt="AI handshake"
              className="w-[158px] h-[68px] object-cover rounded-xl mr-1 cursor-pointer"
              onClick={() => history.push("/")}
            />         
          </div>

          <h2 className="text-textTitle text-2xl font-semibold mb-2">
            Bienvenido de nuevo 👋
          </h2>
          <p className="text-textTipic mb-6">
            Inicia sesión para comenzar a gestionar tu negocio.
          </p>

          <label className="text-textLabel block text-sm font-medium">
            Email
          </label>
          <input
            type="text"
            placeholder="Example@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full text-textTipic p-2 border rounded mb-4"
          />

          <label className="text-textLabel block text-sm font-medium">
            Contraseña
          </label>
          <input
            type="password"
            placeholder="At least 8 characters"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full text-textTipic p-2 border rounded mb-4"
          />

          <a href="#" className="text-sm text-textPrimary">
            ¿Olvidó su contraseña?
          </a>

          <button
            onClick={() => login(email, password)} // Llamar a la función al hacer clic
            className="w-full bg-bgPrimary text-white py-2 rounded mt-4"
            disabled={loading} // Deshabilitar el botón mientras carga
          >
            {loading ? "Cargando..." : "ENTRAR"}
          </button>

          <p className="text-xs text-gray-400 text-center mt-4">
            © 2023 ALL RIGHTS RESERVED
          </p>
        </div>
      </div>

      {/* Sección Derecha - Imagen */}
      <div className="flex w-full lg:w-1/2 items-center justify-center lg:p-16 p-0 ">
        <div className="w-full h-[300px] lg:h-[800px] object-cover flex items-center justify-center">
          <img
            src={imagenLogin}
            alt="AI handshake"
            className="w-full h-full object-cover lg:rounded-xl rounded-none"
          />          
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
